import React from 'react';
import PropTypes from 'prop-types';

import { hasRoleAdmin } from 'common/userRoles';

import SrFlex from 'client/components/SrFlex';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrPartnerBillingSectionHeaderAction from 'client/components/SrPartnerBillingSection/SrPartnerBillingSectionHeaderAction';

export const SR_PARTNER_BILLING_MODAL_RENEWAL = 'renewal';
export const SR_PARTNER_BILLING_MODAL_DISCOUNT = 'discount';

const SR_PARTNER_BILLING_ACTIONS = [
  {
    name: 'Charge Renewal',
    modal: SR_PARTNER_BILLING_MODAL_RENEWAL,
  },
  {
    name: 'Create Discount',
    modal: SR_PARTNER_BILLING_MODAL_DISCOUNT,
  },
  {
    name: 'Billing Settings',
    redirectUrl: 'settings/admin',
  },
];

const SrPartnerBillingSectionHeader = ({ currentUser, openModal }) => {
  const isAdmin = currentUser?.roles && hasRoleAdmin(currentUser.roles);

  if (!isAdmin) {
    return null;
  }

  const partnerBillingActions = SR_PARTNER_BILLING_ACTIONS.map((action) => {
    const { name, redirectUrl, modal } = action;
    const onClick = modal ? () => openModal(modal) : undefined;

    return (
      <SrPartnerBillingSectionHeaderAction
        key={name}
        name={name}
        to={redirectUrl}
        onClick={onClick}
      />
    );
  });

  return (
    <SrFlex lineHeight="40px" width="calc(100% - 100px)" justify="end" align="baseline">
      <SrBox>
        <SrText font="greycliff" weight="600" fontSize="16px">
          Admin only:
        </SrText>
      </SrBox>
      {partnerBillingActions}
    </SrFlex>
  );
};

SrPartnerBillingSectionHeader.displayName = 'SrPartnerBillingSectionHeader';
SrPartnerBillingSectionHeader.propTypes = {
  currentUser: PropTypes.object.isRequired,
  openModal: PropTypes.func.isRequired,
};

export default SrPartnerBillingSectionHeader;
